var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { DRNUtil } from '@traveloka/district-util';
import { withTheme } from '../../theme';
import VARIANT from './textVariant';
import INK_VARIANT from './inkVariant';
import getDefaultStyle from './utils/getDefaultStyle';
import getDefaultInk from './utils/getDefaultInk';
import getDefaultAccesibilityProps from './utils/getDefaultAccesibilityProps';
import withSmartKey from '../../smartkey/withSmartKey';
class BaseText extends React.Component {
    render() {
        const _a = this.props, { style, theme, variant, ink } = _a, props = __rest(_a, ["style", "theme", "variant", "ink"]);
        const defaultStyle = getDefaultStyle(variant);
        const inkColor = theme[getDefaultInk(ink)];
        const textStyle = [
            defaultStyle,
            { color: inkColor },
            styles.text,
            style,
        ];
        let textProps = Object.assign({}, props, { style: textStyle });
        if (DRNUtil.isWeb()) {
            const defaultAccessibilityProps = getDefaultAccesibilityProps(variant);
            // Ignore to allow assigning non standard react-native props
            // @ts-ignore
            textProps = Object.assign({}, defaultAccessibilityProps, textProps);
        }
        return <Text {...textProps}/>;
    }
}
BaseText.smartKeyName = 'children';
BaseText.defaultProps = {
    variant: VARIANT.UI_BASELINE,
    ink: INK_VARIANT.PRIMARY,
};
const styles = StyleSheet.create({
    text: {
        // To support RTL, give a default value left of textAlign
        textAlign: 'left',
    },
});
const DRNText = withTheme(BaseText);
DRNText['VARIANT'] = VARIANT;
DRNText['INK_VARIANT'] = INK_VARIANT;
export default withSmartKey(DRNText);
